import React from 'react';
import { Phone, PaintBucket, Hammer, CheckCircle } from 'lucide-react';
import { FadeIn } from './ScrollReveal';

const Collections = () => {
  const workflowSteps = [
    { icon: Phone, title: 'Kostenlose Beratung', description: 'Vor-Ort-Termin & Kostenvoranschlag' },
    { icon: PaintBucket, title: 'Materialauswahl', description: 'Gemeinsame Fliesenwahl' },
    { icon: Hammer, title: 'Professionelle Ausführung', description: 'Präzise Verlegung' },
    { icon: CheckCircle, title: 'Abnahme & Garantie', description: '5 Jahre Garantie auf alle Arbeiten' }
  ];

  return (
    <section id="arbeitsablauf" className="py-16 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        <FadeIn>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-stone-800 mb-4">
              Unser Arbeitsablauf
            </h2>
            <p className="text-stone-600 font-light max-w-2xl mx-auto">
              Von der ersten Beratung bis zur Garantie - transparent und professionell.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-4 gap-8">
          {workflowSteps.map((step, index) => {
            const Icon = step.icon;
            return (
              <FadeIn key={index} delay={index * 100}>
                <div className="text-center">
                  <div className="w-16 h-16 bg-primary-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-lg font-medium text-stone-800 mb-2">{step.title}</h3>
                  <p className="text-sm text-stone-600">{step.description}</p>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Collections; 